export default "__VITE_ASSET__D9nkbI4f__"